/// <amd-module name="Test/TestFlaky/Source/TestFlakySource" />
import * as TestManagementService from "Test/Client/TestManagementServices";
import { TestCaseResultIdentifier } from "Test/common-util/Common";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { IVssPageContext } from "VSS/Platform/Context";

export class TestFlakySource {
    private static _instance: TestFlakySource;

    public static getInstance(): TestFlakySource {
        if (TestFlakySource._instance) {
            return TestFlakySource._instance;
        }
        TestFlakySource._instance = new TestFlakySource();
        return TestFlakySource._instance;
    }

    private _detailedTestResultCache: any = {};

    public getTestRunById(context: IVssPageContext, runId: number): Promise<TCMContracts.TestRun> {
        return new Promise<TCMContracts.TestRun>((resolve, reject) => {
            if (this._detailedTestResultCache[runId]) {
                resolve(this._detailedTestResultCache[runId]);
            } else {
                const tcmService = context.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
                tcmService
                    .getTestRunById(runId, true)
                    .then((value: TCMContracts.TestRun) => {
                        this._detailedTestResultCache[runId] = value;
                        resolve(value);
                    })
                    .catch((reason: any) => {
                        reject(reason);
                    });
            }
        });
    }

    public getSelectedTestCaseResult(context: IVssPageContext, runId: number, resultId: number): Promise<TCMContracts.TestCaseResult> {
        const testCaseResultIdentifier = new TestCaseResultIdentifier(runId, resultId).toString();
        return new Promise<TCMContracts.TestCaseResult>((resolve, reject) => {
            if (this._detailedTestResultCache[testCaseResultIdentifier]) {
                resolve(this._detailedTestResultCache[testCaseResultIdentifier]);
            } else {
                const tcmService = context.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
                tcmService
                    .getResultById(runId, resultId, TCMContracts.ResultDetails.SubResults)
                    .then((value: TCMContracts.TestCaseResult) => {
                        this._detailedTestResultCache[testCaseResultIdentifier] = value;
                        resolve(value);
                    })
                    .catch((reason: any) => {
                        reject(reason);
                    });
            }
        });
    }

    public updateTestResultMetaData(
        context: IVssPageContext,
        testCaseRefId: number,
        testResultMetaDataUpdateInput: TCMContracts.TestResultMetaDataUpdateInput
    ): Promise<TCMContracts.TestResultMetaData> {
        const tcmService = context.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        return tcmService.updateTestResultsMetaData(testCaseRefId, testResultMetaDataUpdateInput);
    }

    public updateTestResults(
        context: IVssPageContext,
        results: TCMContracts.TestCaseResult[],
        runId: number
    ): Promise<TCMContracts.TestCaseResult[]> {
        const tcmService = context.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        return tcmService.updateTestResults(results, runId);
    }

    public getTestResultsMetadata(
        context: IVssPageContext,
        testCaseReferenceIds: string[],
        detailsToInclude?: TCMContracts.ResultMetaDataDetails
    ): Promise<TCMContracts.TestResultMetaData[]> {
        const tcmService = context.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
        return tcmService.getTestResultsMetadata(testCaseReferenceIds, detailsToInclude);
    }
}
